export const MAX_FILE_SIZE = 20971520; // 20mb
export const ACCEPTED_FILE_TYPES = {
  'image/png': ['.png', '.jpg'],
  'application/pdf': ['.pdf'],
};
